module.exports = __webpack_public_path__ + "static/media/Left_Brick.83a824d4.png";